module.exports = __webpack_public_path__ + "static/media/xwing.1dea7bf4.png";